import { axios, axios2 } from '@/lib/axios';
import { ApiResponse, Subscription } from '@/types';

export type LawyerDTO = {
  finalize_request_id: string;
  lawyer_signature: string;
};

export const finalizeLawyer = (
  data: LawyerDTO
): Promise<
  ApiResponse<{
    status_code: number;
    message: string;
  }>
> => {
  return axios2.post('/lawyer-api/complete-finalize-lawyer', data);
};


export const acceptOrRejectOffer = (data) => {
  return axios2.post('/lawyer-api/accept-reject-user-contract-request',data)
};

export const acceptOrRejectLawyerRequest = (data) => {
  return axios2.post('/lawyer-api/approve-property-request',data)
};